var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChip500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_6164_54862)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 8,
    rx: 10,
    ry: 8,
    fill: "#A046D3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_6164_54862)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 7.9999,
    rx: 7,
    ry: 5.6,
    fill: "url(#paint0_linear_6164_54862)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50793 10.6108C2.30159 10.2111 2.14286 9.79851 2.03174 9.37305C1.98413 9.19254 1.95238 9.01204 1.92063 8.83154L0 9.02494C0.031746 9.25701 0.0793651 9.47619 0.142857 9.69537C0.285714 10.224 0.47619 10.7397 0.746031 11.2296C0.79365 11.3199 0.841269 11.4101 0.904761 11.5004L2.65079 10.8299C2.5873 10.7526 2.53968 10.6752 2.50793 10.6108Z",
    fill: "#3E0E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4285 12.493L16.8095 11.6292C16.5079 12.003 16.1428 12.364 15.7619 12.6864C15.5555 12.854 15.3174 13.0216 15.0952 13.1763L16.3016 14.4011C16.5873 14.2077 16.873 14.0143 17.127 13.7952C17.619 13.3955 18.0476 12.97 18.4285 12.493Z",
    fill: "#3E0E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96827 14.1435C6.60319 14.0274 6.23811 13.8856 5.90478 13.718L4.93652 15.0718C5.36509 15.2781 5.80954 15.4457 6.26985 15.6004C6.79366 15.768 7.33334 15.9098 7.90477 16.0001L8.31747 14.4658C7.82541 14.3884 7.39684 14.2853 6.96827 14.1435Z",
    fill: "#3E0E5A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.492 5.40206C17.6983 5.80174 17.8571 6.21432 17.9682 6.63978C18.0158 6.82029 18.0475 7.00079 18.0793 7.18129L19.9999 6.98789C19.9682 6.75582 19.9205 6.53664 19.857 6.31746C19.7142 5.78885 19.5237 5.27313 19.2539 4.7832C19.2063 4.69295 19.1586 4.6027 19.0951 4.51245L17.3491 5.18288C17.4126 5.26024 17.4444 5.32471 17.492 5.40206Z",
    fill: "#3E0E5A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0318 1.85658C13.3969 1.97262 13.762 2.11444 14.1112 2.28205L15.0794 0.928291C14.6509 0.722004 14.2064 0.554396 13.7461 0.399681C13.2223 0.232073 12.6826 0.0902505 12.1112 0L11.7144 1.53426C12.1588 1.61162 12.6032 1.72765 13.0318 1.85658Z",
    fill: "#3E0E5A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23796 3.32633C4.44431 3.15872 4.6824 2.99112 4.90462 2.8364L3.69827 1.61157C3.41256 1.80497 3.12684 1.99836 2.87288 2.21754C2.38081 2.61722 1.95224 3.04269 1.57129 3.51973L3.19034 4.38355C3.49192 3.99676 3.84113 3.64865 4.23796 3.32633Z",
    fill: "#3E0E5A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1427 15.2395C12.3706 15.2395 12.5554 15.0894 12.5554 14.9043C12.5554 14.7192 12.3706 14.5691 12.1427 14.5691C11.9148 14.5691 11.73 14.7192 11.73 14.9043C11.73 15.0894 11.9148 15.2395 12.1427 15.2395Z",
    fill: "#3E0E5A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96836 1.43093C8.19629 1.43093 8.38106 1.28085 8.38106 1.09571C8.38106 0.910579 8.19629 0.760498 7.96836 0.760498C7.74044 0.760498 7.55566 0.910579 7.55566 1.09571C7.55566 1.28085 7.74044 1.43093 7.96836 1.43093Z",
    fill: "#3E0E5A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.39683 7.09109C1.62476 7.09109 1.80953 6.941 1.80953 6.75587C1.80953 6.57074 1.62476 6.42065 1.39683 6.42065C1.1689 6.42065 0.984131 6.57074 0.984131 6.75587C0.984131 6.941 1.1689 7.09109 1.39683 7.09109Z",
    fill: "#3E0E5A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68247 13.2666C3.9104 13.2666 4.09517 13.1165 4.09517 12.9314C4.09517 12.7463 3.9104 12.5962 3.68247 12.5962C3.45455 12.5962 3.26978 12.7463 3.26978 12.9314C3.26978 13.1165 3.45455 13.2666 3.68247 13.2666Z",
    fill: "#3E0E5A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4762 9.97903C18.7041 9.97903 18.8889 9.82895 18.8889 9.64381C18.8889 9.45868 18.7041 9.30859 18.4762 9.30859C18.2482 9.30859 18.0635 9.45868 18.0635 9.64381C18.0635 9.82895 18.2482 9.97903 18.4762 9.97903Z",
    fill: "#3E0E5A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4603 3.60988C16.6882 3.60988 16.873 3.4598 16.873 3.27467C16.873 3.08953 16.6882 2.93945 16.4603 2.93945C16.2324 2.93945 16.0476 3.08953 16.0476 3.27467C16.0476 3.4598 16.2324 3.60988 16.4603 3.60988Z",
    fill: "#3E0E5A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82553 10.4141L7.39233 10.9114H12.5972L12.164 10.4141H7.82553Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58386 8.52842L8.3802 8.76212L7.59915 9.65948H7.23061C6.98362 9.65948 6.76896 9.55092 6.65646 9.36963C6.54396 9.18834 6.56206 8.98084 6.7056 8.81453L9.18517 5.94917V6.89359V7.83748V10.1568H9.78647V7.99792V4.3999L6.2168 8.52521C5.9433 8.84073 5.90709 9.25144 6.12175 9.59691C6.33641 9.94238 6.7612 10.1568 7.23061 10.1568H8.58386V8.52842Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3984 8.52842L11.6021 8.76212L12.3831 9.65948H12.7517C12.9987 9.65948 13.2133 9.55092 13.3258 9.36963C13.4383 9.18834 13.4202 8.98085 13.2767 8.81453L10.7971 5.94917V6.89359V7.83748V10.1568H10.1958V7.99792V4.3999L13.7661 8.52521C14.0396 8.84073 14.0758 9.25144 13.8612 9.59691C13.6465 9.94238 13.2217 10.1568 12.7523 10.1568H11.3991V8.52842H11.3984Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_6164_54862",
    x: 0,
    y: 0,
    width: 20,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.243137 0 0 0 0 0.054902 0 0 0 0 0.352941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6164_54862"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6164_54862",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6164_54862"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_6164_54862",
    x: 3,
    y: 2.3999,
    width: 14,
    height: 11.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6164_54862"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6164_54862",
    x1: 5.03154,
    y1: 3.99582,
    x2: 12.7694,
    y2: 13.6681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A046D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#450C65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip500);
export default __webpack_public_path__ + "static/media/chip_500.70a6ec33b0be938c16a811ee41b8ea7c.svg";
export { ForwardRef as ReactComponent };